import React from "react";
import CreateAccount from "../../components/CreateAccount";

const CreateAccountPage = () => {
  return <CreateAccount />;
};

export default CreateAccountPage;
